import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  Container,
  Divider,
  Header,
  Image,
  Input,
  Segment,
  Table
} from 'semantic-ui-react';
import axios from 'axios';

import UserDetail from '../components/UserDetail';
import { useError } from '../providers';

const Admin = () => {
  const [users, setUsers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');

  const { showError } = useError();

  useEffect(() => {
    const getUsers = async () => {
      try {
        const { data }  = await axios(
          `/api/admin/users`,
        );
        if (data.status === 200) {
          setUsers(data.response.users || []);
          setFiltered(data.response.users || []);
        } else if (data.status === 401) {
          window.location = '/dashboard';
        }
      } catch(err) {
        showError(<center>Oops, something went wrong. Don't worry, we've been notified of the issue and will fix it as soon as possible!</center>);
      }
    }

    getUsers();
  }, [showError]);

  const updateFilter = (search) => {
    setSearch(search);

    setFiltered(users.filter((user) => {
      if (user.display_name.toLowerCase().indexOf(search.toLowerCase()) !== -1) return true;
      return false;
    }));
  }

  return (
    <Segment inverted>
      <Container text className='description'>
        <Breadcrumb size='huge'>
          <Breadcrumb.Section link as={Link} to='/dashboard'>Dashboard</Breadcrumb.Section>
          <Breadcrumb.Divider icon='right chevron' />
          <Breadcrumb.Section active>Admin</Breadcrumb.Section>
        </Breadcrumb>
        <Divider hidden />
        <p>
          Filter users:{'  '}
          <Input
            icon={{ name: 'search', circular: true, link: true }}
            placeholder='Filter...'
            value={search}
            onChange={(ev) => updateFilter(ev.target.value)}
          />
        </p>
      </Container>
      <br />
      <Table inverted singleLine striped unstackable>
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan={2}>
              Twitch Name
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Object.values(filtered).length === 0 ?
            <Table.Row>
              <Table.Cell colSpan={2}>
                <Header textAlign='center' style={{'color': 'white'}}>
                  No users to display.
                </Header>
              </Table.Cell>
            </Table.Row>
          :
            Object.values(filtered).map((user, index) =>
              <Table.Row key={index}>
                <Table.Cell>
                  <Image avatar src={user.profile_image} />{'  '}
                  <strong>
                    {user.display_name}
                  </strong>
                </Table.Cell>
                <Table.Cell collapsing>
                  <UserDetail user={user} />
                </Table.Cell>
              </Table.Row>
            )
          }
        </Table.Body>
      </Table>
    </Segment>
  )
};

export default Admin;
